import { createSlice } from "@reduxjs/toolkit";
import { getAllDocuments } from "../documentUploadApi";

const getAllDocumentSlice = createSlice({
  name: "getAllDocument",
  initialState: {
    publicData: [],
    privateData: [],
    allDocs: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllDocuments.fulfilled, (state, action) => {
        state.loading = false;
        const { access, data } = action.payload; // Expecting response to include access type
        if (access === "public") {
          state.publicData = data;
        } else if (access === "private") {
          state.privateData = data;
        } else {
          state.allDocs = data;
        }
      })
      .addCase(getAllDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getAllDocumentSlice.reducer;
